import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/customTable';

import TitleDemandStatesMap from '../../../components/statesMap/countyLevel/titleDemandStatesMap';
import TitleLocationStatesMap from '../../../components/statesMap/countyLevel/titleLocationStatesMap';
import TitleSalaryStatesMap from '../../../components/statesMap/countyLevel/titleSalaryStatesMap';

const HEATMAPS = {
  TITLE_SALARY: 'TITLE_SALARY',
  TITLE_LOCATION: 'TITLE_LOCATION',
  TITLE_DEMAND: 'TITLE_DEMAND',
};

const ARTICLE_SUBTYPES = {
  INTRO: 'division-by-location-section',
  TITLE_SALARY: 'where-earn-more-section',
  TITLE_LOCATION: 'where-are-located-section',
  TITLE_DEMAND: 'where-are-demand',
};

const propTypes = {
  heatmapsData: PropTypes.objectOf(PropTypes.any).isRequired,
  criteria: PropTypes.objectOf(PropTypes.any).isRequired,
  onAllHeatmapsLoadError: PropTypes.func.isRequired,
  articleData: PropTypes.arrayOf(PropTypes.object),
  demographicsData: PropTypes.objectOf(PropTypes.any),
};

const defaultProps = {
  articleData: [],
  demographicsData: {},
};

const titleByStateTableConfig = {
  rank: {
    columnName: 'Rank',
    defaultSortDirection: 'asc',
  },
  stateName: {
    columnName: 'State',
    isLink: 'titleStateJobsLink',
    linkUrl: 'titleStateJobsLink',
    linkTitle: 'stateColLinkTitle',
  },
  jobTitleJobsCountFormatted: {
    columnName: 'Number of Jobs',
    customSortByField: 'jobTitleJobsCount',
  },
  nationalAverageAnnualSalaryFormatted: {
    columnName: 'Average Salary',
    customSortByField: 'nationalAverageAnnualSalary',
    isLink: 'titleSalaryStateLink',
    linkUrl: 'titleSalaryStateLink',
    linkTitle: 'salaryColLinkTitle',
  },
};

class HeatmapsSection extends Component {
  constructor(props) {
    super(props);

    const { _getArticleBySubtype } = this;
    const { demographicsData } = props;
    const { salaryMapExists, demandMapExists, supplyMapExists } = demographicsData || {};

    this.state = {
      showHeatmap: {
        [HEATMAPS.TITLE_SALARY]: !!salaryMapExists,
        [HEATMAPS.TITLE_LOCATION]: !!supplyMapExists,
        [HEATMAPS.TITLE_DEMAND]: !!demandMapExists,
      },
      articles: {
        intro: _getArticleBySubtype(ARTICLE_SUBTYPES.INTRO),
        titleSalary: _getArticleBySubtype(ARTICLE_SUBTYPES.TITLE_SALARY),
        titleLocation: _getArticleBySubtype(ARTICLE_SUBTYPES.TITLE_LOCATION),
        titleDemand: _getArticleBySubtype(ARTICLE_SUBTYPES.TITLE_DEMAND),
      },
    };
  }

  _onMapLoadError = (error, type) => {
    this.setState((prevState) => ({
      showHeatmap: {
        ...prevState.showHeatmap,
        [type]: false,
      },
    }));
  };

  _getArticleBySubtype = (articleSubtype = '') => {
    const { articleData } = this.props;

    if (!articleData || !Array.isArray(articleData) || !articleData.length) {
      return '';
    }

    const article = articleData.find(
      (articleDataItem) => articleDataItem.post_subtype === articleSubtype
    );
    if (article && article.content && article.content.length) {
      return article.content;
    }
    return '';
  };

  render() {
    const { _onMapLoadError } = this;
    const { criteria, heatmapsData = {}, onAllHeatmapsLoadError, demographicsData } = this.props;
    const { showHeatmap, articles } = this.state;
    const {
      titleSalaryStatesMapOriginalUrl,
      titleLocationStatesMapOriginalUrl,
      titleDemandStatesMapOriginalUrl,
      titleSalaryStatesMapWidgetUrl,
      titleLocationStatesMapWidgetUrl,
      titleDemandStatesMapWidgetUrl,
    } = heatmapsData;

    const { jobTitlePlural, title } = criteria;

    const {
      intro: introArticle,
      titleSalary: titleSalaryArticle,
      titleLocation: titleLocationoArticle,
      titleDemand: titleDemandArticle,
    } = articles;

    const showTitleSalaryHeatmap = showHeatmap[HEATMAPS.TITLE_SALARY];
    const showTitleLocationHeatmap = showHeatmap[HEATMAPS.TITLE_LOCATION];
    const showTitleDemandHeatmap = showHeatmap[HEATMAPS.TITLE_DEMAND];

    const hideAllHeatmaps = !Object.keys(showHeatmap)
      .map((key) => showHeatmap[key])
      .some(Boolean);
    if (hideAllHeatmaps) {
      onAllHeatmapsLoadError();
      return <></>;
    }

    return (
      <div className="row">
        <div className="col-xl-8">
          <h2 className="brandonH2 z-mb-48 w-730">{`${title} location demographics`}</h2>
          {introArticle && (
            <div className="w-730 z-mb-48" dangerouslySetInnerHTML={{ __html: introArticle }} />
          )}
          {showTitleSalaryHeatmap && (
            <div className="z-mb-68">
              <p className="open-sans-large-black-bold mb-4 w-730 text-capitalize">
                {`Where do ${jobTitlePlural?.toLowerCase?.()} earn the most?`}
              </p>
              {titleSalaryArticle && (
                <div
                  className="mb-4 w-730"
                  dangerouslySetInnerHTML={{ __html: titleSalaryArticle }}
                />
              )}
              <TitleSalaryStatesMap
                key={HEATMAPS.TITLE_SALARY}
                title={title}
                name="whereDoEarnTheMost"
                onMapLoadError={(error) => _onMapLoadError(error, HEATMAPS.TITLE_SALARY)}
                embedWidgetUrl={titleSalaryStatesMapWidgetUrl}
                originalUrl={titleSalaryStatesMapOriginalUrl}
                isEmbeddable
              />
            </div>
          )}
          {showTitleLocationHeatmap && (
            <div className="z-mb-68">
              <p id="by-city" className="open-sans-large-black-bold w-730 text-capitalize">
                {`Which city has the most ${jobTitlePlural}?`}
              </p>
              {titleLocationoArticle && (
                <div
                  className="mb-4 w-730"
                  dangerouslySetInnerHTML={{ __html: titleLocationoArticle }}
                />
              )}
              <TitleLocationStatesMap
                key={HEATMAPS.TITLE_LOCATION}
                title={title}
                name="whereAreLocated"
                jobTitlePlural={jobTitlePlural}
                onMapLoadError={(error) => _onMapLoadError(error, HEATMAPS.TITLE_LOCATION)}
                embedWidgetUrl={titleLocationStatesMapWidgetUrl}
                originalUrl={titleLocationStatesMapOriginalUrl}
                isEmbeddable
              />

              <h3 id="by-state" className="zp-title-h3 text-capitalize mb-4 mt-5">
                {`${title} jobs by state`}
              </h3>

              <Table
                tableHeaderTitleContent={false}
                columnConfig={titleByStateTableConfig}
                bodyData={demographicsData.states}
                defaultRowsDisplay={51}
                scrollOnMobile
              />
            </div>
          )}
          {showTitleDemandHeatmap && (
            <div>
              <p className="open-sans-large-black-bold w-730 text-capitalize">
                {`Where are ${jobTitlePlural?.toLowerCase?.()} in high demand?`}
              </p>
              {titleDemandArticle && (
                <div
                  className="mb-4 w-730"
                  dangerouslySetInnerHTML={{ __html: titleDemandArticle }}
                />
              )}
              <TitleDemandStatesMap
                key={HEATMAPS.TITLE_DEMAND}
                title={title}
                name="whereAreInHighDemand"
                onMapLoadError={(error) => _onMapLoadError(error, HEATMAPS.TITLE_DEMAND)}
                embedWidgetUrl={titleDemandStatesMapWidgetUrl}
                originalUrl={titleDemandStatesMapOriginalUrl}
                isEmbeddable
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

HeatmapsSection.propTypes = propTypes;
HeatmapsSection.defaultProps = defaultProps;

export default HeatmapsSection;
